export enum SignUpOrigin {
    SIGNUP_FORM,
    OVERLAY
}
